// extracted by mini-css-extract-plugin
module.exports = {"snippetWrapper":"highlightCode_snippetWrapper_KeiphEB","codeCopy":"highlightCode_codeCopy_Ma1Kz8X","snippet":"highlightCode_snippet_26weaD8"};